export default {
  title: 'Historial de compras',
  subtitle: 'Encuentra aquí las compras realizadas en este portal en los últimos 90 días:',
  form: {
    date_label: 'Filtrar por:',
    type_label: 'Tipo:',
    error_date: 'Seleccione un rango de fechas válido'
  },
  button: {
    apply: 'Aplicar filtros',
    reset: 'Restaurar'
  },
  empty: {
    title: 'Sin información que mostrar',
    description: 'No se encontró información dentro del rango de fechas seleccionado'
  }
}
